import { EditorShell } from './components/layout/EditorShell';
import { ModalHost } from './components/dialogs/ModalHost';
import { ToastViewport } from './components/ui/ToastViewport';
import { useAutosaveRecovery } from './hooks/useAutosaveRecovery';
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts';
import { usePlaybackClock } from './hooks/usePlayback';
import { useWorkspacePreferences } from './hooks/useWorkspacePreferences';
import { useEditorStore } from './store/editorStore';

export default function App() {
  useAutosaveRecovery();
  useKeyboardShortcuts();
  usePlaybackClock();
  useWorkspacePreferences();
  const ready = useEditorStore((state) => state.ready);
  return <>{ready ? <EditorShell /> : <LoadingScreen />}<ModalHost /><ToastViewport /></>;
}

function LoadingScreen() {
  return <div className="loading-screen"><div className="loading-mark"><span /></div><b>OPEN MOTION</b><small>RESTORING LOCAL WORKSPACE</small><i /></div>;
}
